import type { PdfLink, PdfLinkLage } from './pdf-dokument'

/** Die Lage nach einer Drehung der Seite im Uhrzeigersinn (0, 90, 180, 270 Grad). */
export function dreheLage<T extends PdfLinkLage>(lage: T, drehung: number): T {
  switch (((drehung % 360) + 360) % 360) {
    case 90:
      return { ...lage, links: 100 - lage.oben - lage.hoehe, oben: lage.links, breite: lage.hoehe, hoehe: lage.breite }
    case 180:
      return { ...lage, links: 100 - lage.links - lage.breite, oben: 100 - lage.oben - lage.hoehe }
    case 270:
      return { ...lage, links: lage.oben, oben: 100 - lage.links - lage.breite, breite: lage.hoehe, hoehe: lage.breite }
    default:
      return lage
  }
}

export function ueberlappt(a: PdfLinkLage, b: PdfLinkLage): boolean {
  return a.links < b.links + b.breite && b.links < a.links + a.breite && a.oben < b.oben + b.hoehe && b.oben < a.oben + a.hoehe
}

/** Ein Link, wie die Seite ihn zeichnet. */
export interface PdfLinkAnsicht extends PdfLinkLage {
  readonly href: string
  /** Webseiten im neuen Tab; `mailto:` und `tel:` nicht, sonst bliebe ein leerer Tab stehen. */
  readonly neuesFenster: boolean
  /** Ziel eines Sprungs innerhalb des Dokuments (Seite ab 1). */
  readonly seite?: number
  readonly beschriftung: string
}

export function linkAnsicht(link: PdfLink, drehung: number): PdfLinkAnsicht {
  const lage = dreheLage(link, drehung)
  const ziel = link.ziel
  const geometrie = { links: lage.links, oben: lage.oben, breite: lage.breite, hoehe: lage.hoehe }
  if ('seite' in ziel) {
    return { ...geometrie, href: '#', neuesFenster: false, seite: ziel.seite, beschriftung: `Zu Seite ${ziel.seite}` }
  }
  const web = /^https?:/i.test(ziel.adresse)
  return {
    ...geometrie,
    href: ziel.adresse,
    neuesFenster: web,
    beschriftung: web ? ziel.adresse : decodeURIComponent(ziel.adresse.replace(/^(?:mailto|tel):/i, '')),
  }
}
